import type {
  BooleanField,
  GeoPoint,
  NestableWidget,
  Separator,
  UID
} from "@prismicio/types-internal/lib/customtypes"

type Widgets = NestableWidget | UID
type Field = Exclude<Widgets, Separator | GeoPoint>

export function getFieldLabel(field: Widgets): string {
  return (
    field.config?.label ??
    (field.type === "Boolean" || field.type === "Separator"
      ? undefined
      : field.fieldset) ??
    field.type
  )
}

export const DEFAULT_PLACEHOLDER = "..."

export function getFieldPlaceholder(field: Exclude<Field, BooleanField>): string
export function getFieldPlaceholder(field: BooleanField, value: boolean): string
export function getFieldPlaceholder(field: Field, value?: boolean): string {
  if (field.type === "Boolean") {
    return (
      (value
        ? field.config?.placeholder_true
        : field.config?.placeholder_false) || DEFAULT_PLACEHOLDER
    )
  } else {
    return field.config?.placeholder || DEFAULT_PLACEHOLDER
  }
}
